module.exports = __webpack_public_path__ + "static/media/image-redo.87c2031e.svg";